<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="p-d-flex p-jc-center title" [ngSwitch]="memberEventData?.event_kbn.id">
      <div>
        <label class="p-d-flex p-jc-center">地方創生SDGs官民連携プラットフォーム</label>

        <label class="p-d-flex p-jc-center title-name" *ngSwitchCase="1">会員主催イベント・お知らせ</label>
        <label class="p-d-flex p-jc-center title-name" *ngSwitchCase="2">分科会</label>
        <label class="p-d-flex p-jc-center title-name" *ngSwitchCase="3">会員主催イベント・お知らせ</label>
        <label class="p-d-flex p-jc-center title-name" *ngSwitchCase="4">分科会</label>
      </div>
    </div>

    <!-- 編集ボタンエリア
      一旦非表示対応
    <div class="p-d-flex p-jc-center">
      <button
        pButton
        type="button"
        label="編集する"
        icon="pi pi-pencil"
        class="button1"
        (click)="moveE104(memberEventData?.member_event_id)"
        *ngIf="
          decisionPerspective(memberEventData?.member_id) ||
          decisionSecretariat()
        "
      ></button>
    </div>
    <div class="margin-vertical"></div>
    -->

    <!-- 内閣府承認情報 -->
    <div class="approval-information" *ngIf="
        decisionPerspective(this.memberEventData?.member_id) ||
        decisionSecretariat()
      ">
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="3 == memberInformation?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">{{
                      memberEventData?.status.name
                      }}</label>
                    <!-- 承認日付 -->
                    <label>{{ memberEventData?.status_datetime }}</label>
                  </label>

                  <!-- 承認可否 -->
                  <button pButton type="button" label="ステータス登録" class="button3 approval-button"
                    (click)="openSmallApprovalDialog()" *ngIf="decisionSecretariat()"></button>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ memberEventData?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 編集ボタンエリア -->
    <div class="p-d-flex p-jc-end edit-button-group">
      <!-- 編集ボタン -->
      <button
        pButton
        type="button"
        label="編集する"
        icon="pi pi-pencil"
        class="button1"
        (click)="moveE104()"
        *ngIf="
            ((decisionPerspective(this.memberEventData?.member_id) ||
              decisionSecretariat()) &&
              memberEventData &&
              memberEventData.created_by_follow != '1')
        "
      ></button>
    </div>

    <!-- 会員主催イベント詳細 -->
    <div class="member-event-detail">
      <!-- 区分 -->
      <div class="p-text-center">
        <p-tag value="イベント" styleClass="event-tag" *ngIf="1 == memberEventData?.event_kbn.id || 4 == memberEventData?.event_kbn.id"></p-tag>
        <p-tag value="お知らせ" styleClass="information-tag" *ngIf="2 == memberEventData?.event_kbn.id || 3 == memberEventData?.event_kbn.id"></p-tag>
      </div>

      <!-- タイトル -->
      <div class="p-d-flex p-jc-center title" *ngIf="memberEventData?.title.length != 0">{{ memberEventData?.title }}</div>
      <div class="p-d-flex p-jc-center organization_name"
        *ngIf="(1 == memberEventData?.event_kbn.id || 3 == memberEventData?.event_kbn.id) && memberEventData?.event_kbn.id.length != 0">
        {{memberEventData?.organization_name}}
      </div>
      <div class="p-d-flex p-jc-center organization_name"
        *ngIf="(2 == memberEventData?.event_kbn.id || 4 == memberEventData?.event_kbn.id) && memberEventData?.event_kbn.id.length != 0">
        分科会名：{{memberEventData?.theme}}
      </div>

      <!-- 内容 -->
      <div class="detail">
        <label class="detail-title">【内&emsp;容】</label><br />
        <label class="detail-data" *ngIf="memberEventData?.contents.length != 0">{{ memberEventData?.contents }}</label>
      </div>

      <!-- お知らせURL -->
      <div class="detail" *ngIf="!((1 == memberEventData?.event_kbn.id) || (4 == memberEventData?.event_kbn.id)) && memberEventData?.event_page_url.length != 0">
        <label class="detail-title">【お知らせURL】</label><br />
        <label class="detail-data">
          <a [href]="memberEventData?.event_page_url" target="_blank">
            {{ memberEventData?.event_page_url }}
          </a>
        </label>
      </div>

      <!-- イベントURL -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.event_page_url.length != 0">
        <label class="detail-title">【イベントURL】</label><br />
        <label class="detail-data">
          <a [href]="memberEventData?.event_page_url" target="_blank">
            {{ memberEventData?.event_page_url }}
          </a>
        </label>
      </div>

      <!-- 日時 -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.date_and_time.length != 0">
        <label class="detail-title">【日&emsp;時】</label><br />
        <label class="detail-data">{{ memberEventData?.date_and_time }}</label>
      </div>

      <!-- 会場 -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.place.length != 0">
        <label class="detail-title">【会&emsp;場】</label><br />
        <label class="detail-data">{{ memberEventData?.place }}</label>
      </div>

      <!-- 参加費 -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.entry_fee.length != 0">
        <label class="detail-title">【参加費】</label><br />
        <label class="detail-data">{{ memberEventData?.entry_fee }}</label>
      </div>

      <!-- 定員 -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.capacity.length != 0">
        <label class="detail-title">【定員】</label><br />
        <label class="detail-data">{{ memberEventData?.capacity }}</label>
      </div>

      <!-- 主催団体 -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.organizer.length != 0">
        <label class="detail-title">【主催団体】</label><br />
        <label class="detail-data">{{ memberEventData?.organizer }}</label>
      </div>

      <!-- プログラム -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.program.length != 0">
        <label class="detail-title">【プログラム】</label><br />
        <label class="detail-data">{{ memberEventData?.program }}</label>
      </div>

      <!-- 申し込みURL -->
      <div class="detail" *ngIf="!((2 == memberEventData?.event_kbn.id) || (3 == memberEventData?.event_kbn.id)) && memberEventData?.application_page_url.length != 0">
        <label class="detail-title">【申し込みURL】</label><br />
        <label class="detail-data">
          <a [href]="memberEventData?.application_page_url" target="_blank">
            {{ memberEventData?.application_page_url }}
          </a>
        </label>
      </div>

      <!-- 問い合わせ先 -->
      <div class="detail" *ngIf="memberEventData?.contact.length != 0">
        <label class="detail-title">【問い合わせ先】</label><br />
        <label class="detail-data">{{ memberEventData?.contact }}</label>
      </div>

      <!-- その他 -->
      <div class="detail" *ngIf="memberEventData?.others.length != 0">
        <label class="detail-title">【その他】</label><br />
        <label class="detail-data">{{ memberEventData?.others }}</label>
      </div>


    </div>
  </div>

  <!-- 共通部品_承認時ダイアログ -->
  <app-approval-dialog (returnApproval)="getMemberEventData()"></app-approval-dialog>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
